import React, { useState } from 'react';
import { Modal, Tooltip, Form } from 'antd';
import { SpanButton } from 'component/button_components/button.style';
import { BorderNoneInput } from 'component/form_component/style';
import { ReactComponent as ViewIcon } from 'assets/images/SVG/icons/view-icon.svg';
import { getOneOu } from 'redux/slices/getChildOu';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { useDispatch, useSelector } from 'react-redux';
import { SweetSweetAlert } from 'component/sweetalert_components';

const ViewOuProperties = ({ ...record }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [singleOuData, setSingleOuData] = useState(null);
  const selectedNode = useSelector((state) => state.selectedNode);

  const showModal = async () => {
    try {
      setLoading(true);
      const sweetAlert = await dispatch(getOneOu({ ou: record.dnName, fqdn: selectedNode.domainName }));
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        setSingleOuData(sweetAlert.payload.data);
        setIsModalOpen(true);
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Tooltip className='action-tooltip action-tooltip-ou' title='View Properties' color='#597081'>
        <SpanButton className='action-spanbutton action-spanbutton-ou' onClick={showModal}>
          <ViewIcon className='action-icon action-icon-ou-view' />
        </SpanButton>
      </Tooltip>
      {loading && <ModalOpenLoader />}
      {isModalOpen && (
        <Modal className='modal-viewou' open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={[]} centered>
          <h2 className='modal-viewou-heading'>OU Properties</h2>
          <Form
            className='form-view-ou'
            labelCol={{ span: 7 }}
            name='register'
            initialValues={{
              name: singleOuData.name,
              description: singleOuData.description,
              city: singleOuData.city,
              state: singleOuData.state,
              street: singleOuData.street,
              country: singleOuData.country,
              pincode: singleOuData.pincode,
            }}
            scrollToFirstError
          >
            <Form.Item className='viewou-label viewou-label-ou_name' label='OU Name' name='name'>
              <BorderNoneInput className='viewou-data viewou-data-group_name' readOnly />
            </Form.Item>
            <Form.Item className='viewou-label viewou-label-description' label='Description' name='description'>
              <BorderNoneInput className='viewou-data viewou-data-description' readOnly />
            </Form.Item>
            <Form.Item className='viewou-label viewou-label-street' label='Street' name='street'>
              <BorderNoneInput className='viewou-data viewou-data-street' readOnly />
            </Form.Item>
            <Form.Item className='viewou-label viewou-label-city' label='City' name='city'>
              <BorderNoneInput className='viewou-data viewou-data-city' readOnly />
            </Form.Item>
            <Form.Item className='viewou-label viewou-label-state' label='State' name='state'>
              <BorderNoneInput className='viewou-data viewou-data-state' readOnly />
            </Form.Item>
            <Form.Item className='viewou-label viewou-label-country' label='Country' name='country'>
              <BorderNoneInput className='viewou-data viewou-data-country' readOnly />
            </Form.Item>
            <Form.Item className='viewou-label viewou-label-pincode' label='Pincode' name='pincode'>
              <BorderNoneInput className='viewou-data viewou-data-pincode' readOnly />
            </Form.Item>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default ViewOuProperties;
